import { UserActionItem } from '../lib/userActionItems.slice'
import {
  UserActionItemTabPane,
  ACTION_ITEM_TYPE,
} from '../UserActionItemTabPane'

import { TypographyStyles } from '@/styles'
import { Badge, Card, CardColors, Text } from '@/ui'

interface TaxActionItemsCardProps {
  incompleteActionItems: UserActionItem[]
  isUrgent: boolean
}

export const QTEActionItemsCard = ({
  incompleteActionItems,
  isUrgent,
}: TaxActionItemsCardProps) => (
  <Card className="min-h-[300px]" color={CardColors.LEVEL_0}>
    <div className="flex flex-col space-y-4">
      <div className="flex items-center">
        {isUrgent && (
          <Badge color="red" className="mr-2.5">
            Urgent
          </Badge>
        )}

        <Text variant={TypographyStyles.H2}>
          Pay Your Quarterly Tax Estimate
        </Text>
      </div>

      <Text>
        Update your tax information and upload your bank statements in order to
        know how much you need to pay for your quarterly tax estimate.
      </Text>

      <UserActionItemTabPane
        groupOption={'date-asc-groupedby-categoryName'}
        tabPaneType={ACTION_ITEM_TYPE.ACTIVE}
        userActionItems={incompleteActionItems}
        hideCalendar
      />
    </div>
  </Card>
)
